<template>
    <section style="position:relative">
        <div class="theme2">
            <div class="primaryBanner" :style="{backgroundImage: `url(${imagemBanner})`}">
                <div class="contentBanner">
                    <h1>{{tituloBanner}}</h1>
                    <p>{{textoBanner}}</p>
                    <div class="priceBanner" v-if="infoPriceCollection && infoPriceCollection.price">
                        <div class="priceInfo">
                            <h3>R$ {{Number(infoPriceCollection.price).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</h3>
                            <p>ou</p>
                            <h3>{{infoPriceCollection.installment}}x</h3>
                            <p>de </p>
                            <h3>R$ {{Number(infoPriceCollection.price/infoPriceCollection.installment).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</h3>
                        </div>
                        <button class="btnBuy" @click="redirectToCheckout" :style="{ backgroundColor: finalWebsite?.color }">COMPRAR</button>
                    </div>
                    <div class="subscribeBanner" v-if="infoPriceCollection.price == 0 || infoPriceCollection.price == null">
                        <button class="btnBuy subscribe" @click="(()=>{this.$router.push('/planos')})" :style="{ backgroundColor: finalWebsite?.color }">Assinar agora</button>
                    </div>
                </div>
            </div>
            <div class="degrade"></div>
        </div>
    </section>
       
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    props: {
        imagemBanner: {
            type: String,
            required: true
        },
        tituloBanner: {
            type: String,
            required: true
        },
        textoBanner: {
            type: String,
            required: true
        },
        infoPriceCollection: {
            type: Object,
            required: false
        }
    },
    computed: {
        ...mapState(['finalWebsite']),
    },
    methods: {
        ...mapActions(['storeCollectionCheckout']),
        redirectToCheckout() {
            this.storeCollectionCheckout({collectionCheckout: this.infoPriceCollection});
            this.$router.push('/checkout-collection-weflix');        
        },
    }
}
</script>

<style scoped>  
.primaryBanner {
    position: relative;
    width: 100%;
    height: 800px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 64px 0;
}

.degrade {
    position: absolute;
    inset: 0;
    z-index: 1;
    background-image: linear-gradient(to bottom, transparent, #000);
}

.contentBanner {
    position: absolute;
    top: 20%;
    left: 10%;
    z-index: 2;
    max-width: 40%;
    text-align: left;
}

.contentBanner h1 {
    margin-top: 50px;
    color: #fff;
    font-size: 50px;
}

.contentBanner p {
    color: #fff;
    font-size: 18px;
}

.priceBanner {
    margin-top: 20px;
}

.priceInfo h3 {
    color: #fff;
    font-size: 24px;
    margin-bottom: 5px;
}

.priceInfo p {
    font-size: 16px;
    margin: 0;
}

.btnBuy {
    margin-top: 15px;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.btnBuy:hover {
    background: #f40612;
}

@media (max-width: 600px) {
    .contentBanner {
        top: 40%;
        max-width: 80%;
    }

    .contentBanner h1 {
        font-size: 30px;
        margin-top: 20px;
    }

    .contentBanner p {
        font-size: 14px;
        padding: 0 20px;
    }
}
.subscribe {
    transition: all 0.3s ease-in-out !important;
}
.subscribe:hover {
    transform: scale(1.02);
    background-color: #e50914;
    transition: all 0.3s ease-in-out !important;
}
.priceInfo {
    display: flex;
    align-items: anchor-center;
    gap: 5px;
}
</style>
